var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"landing"},[_c('TopBar'),_c('Header'),_c('Carousel'),_c('GetStarted'),_c('Purpose'),_c('WholePicture'),_c('FAQ'),_c('Newsletter'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }